import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledCoverMenu = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  max-height: var(--appheight) !important;
  background-color: #000;
  position: relative;

  .cover-image {
    position: relative;
    flex: 1;

    .cover-title-container {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 20px;
      color: white;
      text-transform: uppercase;
      font-weight: bold;
      font-family: museo-sans;
      text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
      padding: 20px;

      .cover-title {
        font-size: 180%;
        text-align: center;
      }

      .cover-subtitle {
        margin-top: 10px;
        text-align: center;
      }
    }
  }

  .menu {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: ${({ bgMenuImg }) => `url(${bgMenuImg})`};
    background-repeat: repeat;
    background-size: 70%;
    gap: 20px;

    button {
      font-family: museo-sans /* , 'museo_sans500' */;
      font-weight: bold;
      font-size: 110%;
      height: auto;
      min-width: 50%;
      padding: 4px 16px;
      text-transform: uppercase;
      &.normal-case {
        text-transform: none;
      }
      &.normal-weight {
        font-weight: normal;
      }
    }
    .option-info {
      margin-top: -10px;
      margin-bottom: 0;
      color: white;
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    flex-direction: column;
    position: relative;

    .cover-image {
      position: static;

      .cover-title-container {
        height: 50%;
        gap: 10px;

        .wave {
          display: none;
        }
      }
    }

    .menu {
      flex: 0;
      margin: 20px;
      padding: 20px;
      border-radius: 8px;
      background: #000000aa;
      z-index: 1;

      button {
        width: 100%;
      }
    }
  }
`;
